import { styled } from "styled-components";
import { Separator } from "../separator/separator.es.js";
const SPACE_VALUES = {
  none: 0,
  xsmall: 2,
  small: 4,
  medium: 8,
  large: 12
};
const InlineItemImpl = styled("div")(
  {
    minWidth: 0
  },
  ({ $sizing }) => ({
    "fill-container": {
      flexGrow: 1,
      flexShrink: 1,
      flexBasis: 0
    },
    "fit-content": {
      flexGrow: 0,
      flexShrink: 0,
      flexBasis: "auto"
    }
  })[$sizing],
  ({ $ellipsify }) => $ellipsify === true ? {
    flexShrink: 1,
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap"
  } : void 0
);
const InlineImpl = styled("div")(
  {
    display: "flex",
    width: "100%"
  },
  ({ $alignY }) => ({
    alignItems: {
      bottom: "flex-end",
      center: "center",
      stretch: "stretch",
      top: "flex-start"
    }[$alignY]
  }),
  ({ $heightMode }) => ({
    "fill-container": {
      height: "100%"
    },
    "fit-content": {
      height: "auto"
    }
  })[$heightMode],
  ({ $space }) => ({
    [`& > ${InlineItemImpl}:not(:first-child)`]: {
      paddingLeft: SPACE_VALUES[$space]
    },
    [`& > ${InlineItemImpl}:not(:last-child)`]: {
      paddingRight: SPACE_VALUES[$space]
    },
    [`& > ${Separator}`]: {
      paddingLeft: SPACE_VALUES[$space],
      paddingRight: SPACE_VALUES[$space]
    }
  })
);
export {
  InlineImpl,
  InlineItemImpl
};
